import ReactImageFallback from "react-image-fallback";
import {getTeamImage, getFriendlyTeamName} from '../../utils/gameUtils';
import MissingTeamImage from './images/MissingTeam.png';

export const TeamImage = ({league, competitor, ...props}) => {
    const image = getTeamImage(league, competitor);
    const alt = `${getFriendlyTeamName(league, competitor)} Team Image`;
    return (
        <ReactImageFallback {...props}
                            src={image}
                            fallbackImage={MissingTeamImage}
                            initialImage={MissingTeamImage}
                            alt={alt}/>
    )
}